import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

const PostSkeletonLoader = () => {
  return (
    <Box>
      <Stack spacing={2}>
        <Skeleton variant="text" height={60} width="60%" />
        <Skeleton variant="text" height={20} width="60%" />
        <Skeleton variant="rectangular" height={300} width="100%" sx={{ borderRadius: 2 }} />
        {Array.from({ length: 10 }).map((_, idx) => (
          <Skeleton key={idx} variant="text" height={20} width={`${90 - (idx % 3) * 5}%`} />
        ))}
        <Box display="flex" justifyContent="center" mt={4}>
          <Skeleton variant="rectangular" width={160} height={45} sx={{ borderRadius: 3 }} />
        </Box>
      </Stack>
    </Box>
  );
};

export default PostSkeletonLoader;
